import { createStackNavigator } from "@react-navigation/stack"
import type { CreateOrEditOrganizationStackParamList } from "src/types.d"

export const CreateOrEditOrganizationStack = createStackNavigator<CreateOrEditOrganizationStackParamList>()
